import { render } from "./trainingMatrix.svg?vue&type=template&id=1d373b00"
const script = {}
script.render = render

export default script